export default "__VITE_ASSET__6143bcd4__"